// src/pages/events/Webinar2024.js
import React, { useMemo } from 'react';
import { useCollection } from '../../hooks/useCollection';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import './Webinar2024.css'; // reuse existing styles

export default function Webinar2024() {
  const { documents, error } = useCollection('events', null, ['date', 'desc']);

  // Normalize past_event: support boolean true or string "yes"
  const isPast = (doc) => {
    const v = doc?.past_event;
    if (typeof v === 'string') return v.toLowerCase() === 'yes';
    return !!v;
  };

  // Only 2024 Webinar Series + past (on-demand)
  const past2024Docs = useMemo(() => {
    if (!documents) return [];
    const filtered = documents.filter(
      (d) => d?.type === '2024 Webinar Series' && isPast(d)
    );
    // Sort newest first
    filtered.sort((a, b) => b.date.toDate() - a.date.toDate());
    return filtered;
  }, [documents]);

  return (
    <div className="eventCalendarWrapper">
      <Navbar />

      <div className="eventCalendarHeader">
        <h1>Webinar Series</h1>
        <h1>On-Demand</h1>
        <p className="series-subtext">
          Watch recorded webinars from the Neuromodec Webinar Series.
        </p>
      </div>

      {/* Single-column content area (reuse layout styles) */}
      <div className="eventCalendarLayout single">
        {error && <p className="error">{error}</p>}

        {past2024Docs.length === 0 ? (
          <p className="muted">No on-demand webinars are available yet.</p>
        ) : (
          <ul className="eventList">
            {past2024Docs.map((doc) => (
              <li key={doc.id} className="eventListItem">
                <Link to={`/events/${doc.id}`} className="eventCardLink">
                  <div className="eventCardHorizontal">
                    <div className="eventCardImageWrap">
                      <img src={doc.img_url} alt={doc.name} />
                    </div>
                    <div className="eventCardContent">
                      <h3 className="eventTitle">{doc.name}</h3>
                      <p className="eventMeta">
                        {doc.day === ''
                          ? 'Date: TBD'
                          : `${doc.day}, ${doc.month} ${doc.day_digit}, ${doc.year} | ${doc.start_time} - ${doc.end_time} (ET)`}
                      </p>
                      {/* <p className="eventType">{doc.type}</p> */}
                      <span className="completed-badge">Watch Webinar</span>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}

        {/* CTA to main events page */}
        {/* <div style={{ marginTop: 24, textAlign: 'center' }}>
          <Link to="/events" className="btnPrimary" style={{ display: 'inline-block' }}>
            Browse Upcoming Webinars instead
          </Link>
        </div> */}
      </div>
    </div>
  );
}
